<template>
    <div>
        <span v-if="lang === 'EN'">
            <span>Relearn</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
            >
              <div slot="content" style="font-size: 14px;">A: Automatic Relearn<br/>S: Stationary Relearn<br/> O: OBD Relearn<br/> C: Clone</div>
              <i class="el-icon-warning primary-color" style="margin-left:5px;'" />
            </el-tooltip>
          </span>
          <span v-else>
            <span>学习类型</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
            >
              <div slot="content" style="font-size: 14px;">A: 自学习<br/>S: 静态学习<br/> O: OBD 学习<br/> C: 克隆学习</div>
              <i class="el-icon-warning primary-color" style="margin-left:5px;'" />
            </el-tooltip>
          </span>
    </div>
  </template>
  <script>
  export default {
    name: 'relearn-header',
    props: {
        lang: String
    },
    methods: {
    }
  }
  </script>